interface Indexable {
  [key: string]: string | undefined;
}

// this is needed because Error object doesn't have its enumerable properties, 
// which means JSON.stringify will print empty object
const serializableError = (error: any) => {
  if (error instanceof Error) {
    const indexableError = (error as unknown) as Indexable;
    const serializableError = {} as Indexable;

    Object.getOwnPropertyNames(error).forEach(function (propName) {
      serializableError[propName] = indexableError[propName];
    });

    return serializableError;
  }

  return error;
};

export default serializableError;
